import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TextMaskModule } from 'src/app/directives/angular2TextMask';
import { MaskInput } from 'src/app/ui/models/domains/masks/mask.model';
import { PipeModule } from 'src/app/ui/pipes/pipe.module';
import { Toast } from '../../../toast/toast';
import { MatExpansionModule } from '@angular/material/expansion';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { Company } from 'src/app/ui/models/domains/pbm/companies/company';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { RoutePath } from 'src/app/ui/models/domains/route-paths.model';
import { FinancialStatementSearchType, FinancialStatementSearchValidator } from '../financial-statement-search.util';

@Component({
  selector: 'financial-statement-filter',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    PipeModule,
    MatCardModule,
    TextMaskModule,
    FlexLayoutModule,
    MatTooltipModule
  ],
  templateUrl: './financial-statement-filter.component.html',
  styleUrl: './financial-statement-filter.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class FinancialStatementFilterComponent implements OnInit {
  @Input() company: Company;
  @Input() searchInput: any;
  @Input() canExport: boolean = true;
  @Output() emmitSearch = new EventEmitter<any>();
  @Output() emmitExport = new EventEmitter<boolean>();
  rootForm: FormGroup = new FormGroup({
    type: new FormControl(0),
    searchType: new FormControl(1),
    search: new FormControl(''),
  });
  socialNumberMask = MaskInput.getSocialNumberMask();
  cardNumberMask = MaskInput.getCardNumberMask();

  constructor(
    private router: Router,
    private toast: Toast,
  ) { }

  ngOnInit() {
    if (this.searchInput) {
      this.rootForm.patchValue(this.searchInput);
    }
  }

  onPressSearch(event): void {
    if (event.key === "Enter") {
      this.search();
    }
  }

  search() {
    const formValue = this.rootForm.getRawValue();
    const searchType = Number(formValue.searchType);
    const searchValue = formValue.search?.toString() ?? "";

    if (!searchValue.trim()) {
      this.toast.showWarningToast(`Por favor, informe o ${this.getSearchLabel(searchType)} do beneficiário para consulta do extrato.`);
      return;
    }

    const validation = FinancialStatementSearchValidator.validate(searchType, searchValue);
    if (!validation.isValid) {
      this.toast.showWarningToast(validation.errorMessage ?? `Valor inválido para ${this.getSearchLabel(searchType)}.`);
      return;
    }
    formValue.search = FinancialStatementSearchValidator.sanitize(searchType, searchValue);

    this.emmitSearch.emit(formValue);
  }

  export() {
    this.emmitExport.emit(true);
  }

  clear() {
    this.rootForm.reset({ type: 0, searchType: 1, search: '' });
  }

  isSummaryView(): boolean {
    return !this.router.url.includes(RoutePath.FinancialStatementCompany);
  }

  backToSummary(): void {
    this.router.navigate([RoutePath.FinancialStatementCompany], { queryParams: { b: this.company.getFiscalNumber() } });
  }

  changeCompany(): void {
    this.router.navigate([RoutePath.FinancialStatement]);
  }

  private getSearchLabel(searchType: number): string {
    switch (searchType) {
      case FinancialStatementSearchType.CPF:
        return "CPF";
      case FinancialStatementSearchType.NAME:
        return "NOME";
      case FinancialStatementSearchType.CARD:
        return "Nº DO CARTÃO";
      default:
        return "CPF";
    }
  }
}
